class FooterAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
  }

  handleTrigger (event) {
    const clickedTriggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!clickedTriggerEl) return

    this.els.trigger.elements.forEach((triggerEl) => {
      if (triggerEl === clickedTriggerEl) {
        if (triggerEl.classList.contains('ft-Navigation_Trigger-open')) {
          triggerEl.classList.remove('ft-Navigation_Trigger-open')
        } else {
          triggerEl.classList.add('ft-Navigation_Trigger-open')
        }
      } else if (this.dataset.type === 'oneopen') {
        triggerEl.classList.remove('ft-Navigation_Trigger-open')
      }
    })

    this.els.content.elements.forEach((contentEl) => {
      if (contentEl.id === clickedTriggerEl.getAttribute('aria-controls')) {
        if (contentEl.classList.contains('ft-Navigation_Body-open')) {
          contentEl.classList.remove('ft-Navigation_Body-open')
        } else {
          contentEl.classList.add('ft-Navigation_Body-open')
        }
      } else if (this.dataset.type === 'oneopen') {
        contentEl.classList.remove('ft-Navigation_Body-open')
      }
    })
  }
}

if (!customElements.get('footer-accordion')) {
  customElements.define('footer-accordion', FooterAccordion)
}
